
// Dependencies
import validator from 'validator';

export default class Form {

  constructor(root, callback) {
    this.root = root;
    this.fields = Array.prototype.slice.call(root.elements)
      .filter(field => field.hasAttribute('name'))
      .map(field => new FormField(field));
    this.formData = null;
    this.formId = this.root.dataset.formId;

    this.debounce = this.debounce.bind(this);
    this.serializeFormData = this.serializeFormData.bind(this);
    this.callback = callback.bind(this);
  }

  debounce(func, delay) {
  	var timeout;

    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  }

  serializeFormData() {
    const formObject = this.fields.reduce((formData, field) => {
      formData[field.node.getAttribute('name')] = field.node.value;
      formData.dataString = formData.dataString ? formData.dataString += `&${field.node.getAttribute('name')}=${field.node.value}` : `${field.node.getAttribute('name')}=${field.node.value}`;

      return formData;
    }, {});

    formObject.dataString = window.encodeURI(formObject.dataString);

    return formObject;
  }

  init() {
    if (!this.root.noValidate) this.root.noValidate = true;

    this.root.addEventListener('submit', (event) => {
      event.preventDefault();

      // Validate all fields upon submission
      this.fields.forEach(field => field.validateField());

      // If all fields are valid, serialize the form data
      if (this.fields.map(field => field.valid).every(validationStatus => validationStatus)) {
        const recaptchaId = this.root.querySelector(".recaptcha").dataset.recaptchaId;
        this.root.querySelector(`[name="recaptchaToken"]`).value = window.grecaptcha.getResponse(recaptchaId);
        this.formData = this.serializeFormData();
        this.callback(this.root, this.formData);
      }
    });

    // Attach debounced keyup and paste event listeners to text inputs and textareas
    this.fields
      .filter(field => (field.node.hasAttribute('type') && ['text', 'email', 'tel', 'datetime', 'number',].indexOf(field.node.getAttribute('type')) !== -1) || field.node.tagName === 'TEXTAREA')
      .forEach(field => {
        field.node.addEventListener('keyup', () => {
          this.debounce(field.validateField, 150);
        });

        field.node.addEventListener('paste', () => field.validateField);
      });

    this.fields.forEach(field => {
      field.node.addEventListener('change', field.validateField);
      field.node.addEventListener('focusout', field.validateField);
    });
  }

};

class FormField {

  constructor(node) {
    this.node = node;
    this.required = node.hasAttribute('required');
    this.valid = true;

    this.validationFunction = this.validationFunction.bind(this);
    this.validateField = this.validateField.bind(this);
  }

  validateField() {
    if (this.required || (this.node.value && this.node.value !== '')) {
      this.validationFunction();

      this.node.setAttribute('aria-invalid', !this.valid);
    } else if (!this.required && this.node.value === '' && this.node.hasAttribute('aria-invalid')) {
      this.node.removeAttribute('aria-invalid');
    }
  }

  validationFunction() {
    if (this.required && (!this.node.value || this.node.value === '')) {
      return this.valid = false;
    } else if (this.node.value && this.node.value !== '') {
      switch(this.node.type) {
        case 'email':
          return this.valid = validator.isEmail(this.node.value);
        case 'tel':
          return this.valid = validator.isMobilePhone(this.node.value, 'en-US');
        case 'number':
          return this.valid = validator.isNumeric(this.node.value);
        case 'datetime':
          return this.valid = validator.isDate(this.node.value);
        default:
          return this.valid = true;
      }
    }
  }

};



// WEBPACK FOOTER //
// ./components/form.js